<template>
    <div class="templete_box">
        <div class="customer_opt">     
            <div class="search_box clearfix mar_top mar_bot">
                <el-date-picker type="date" placeholder="开始时间" v-model="optParams.start_time" class="search_input search_inputBox" size="mini"></el-date-picker>
                <el-date-picker type="date" placeholder="结束时间" v-model="optParams.end_time" class="search_input search_inputBox" size="mini"></el-date-picker>     
                <el-select v-model="optParams.operator_id" placeholder="用户" class="search_select search_inputBox">
                    <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <div class="reset fcolor" @click="optReset">重置</div>
                <el-button class="publicBtn" @click="optSearch">查询</el-button>
                 <el-button class="operationBtn right" size="mini" @click="returnWorkbench">返回销售工作台</el-button>
            </div>     
            <el-table class="opt_table" :data="operationData" border stripe highlight-current-row  size="mini" style="width:830px;" height="100%">              
                <el-table-column type="index" width="45" align="center"></el-table-column>              
                <el-table-column prop="create_time" label="操作时间" width="160"></el-table-column>
                <el-table-column prop="operator_name" label="用户名" width="100"></el-table-column>
                <!-- <el-table-column prop="remark" label="操作记录" min-width="300"></el-table-column>            -->
                <el-table-column prop="remark" label="操作记录" min-width="300" show-overflow-tooltip></el-table-column>           
            </el-table>
            <!-- 分页 -->
            <div class="opt_pagin" style="width: 800px;">
                <pagination v-if="refresh" ref="pagination" :lastpages.sync="pages.last_page" :currentpages.sync="pages.current_page" :all.sync="pages.total" :pagesizes.sync="pages.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
    </div>
</template>

<script>
import pagination from '../../components/pagination' 
export default {
    components: {
        pagination
    },
    data(){
        return {
            refresh: true,
            optParams: {
                start_time: '',
                end_time: '',
                operator_id: '',
                per_page: 20,
                page: 1
            },
            operationData:[],
            pages: {
                last_page: 0,
                total: 0,
                current_page: 1,
                per_page: 20
            },
            userList: [],
            refresh: true
        }
    },
    methods: {
        getUserList(){
            this.postFunc("erp/user.select", {}, res=>{
                this.userList = res.data.data
            })
        },
        getOperationList(){
            let obj = JSON.parse(JSON.stringify(this.optParams))
            obj.start_time = obj.start_time ? Date.parse(new Date(obj.start_time))/1000 : ''
            obj.end_time = obj.start_time ? (Date.parse(new Date(obj.end_time))/1000 + 86399) : ''
            this.postFunc("erp/customer.index.log", obj, res=>{         
                let resData = res.data.data.data
                resData.forEach(item => {
                    item.create_time = this.formatTimeSecond(item.create_time + '000')
                });
                this.operationData = resData
                let obj = {}
                obj.total = Number(res.data.data.total)
                obj.per_page = Number(res.data.data.per_page)
                obj.current_page = Number(res.data.data.current_page)
                obj.last_page = Number(res.data.data.last_page)
                this.pages = obj
            })
        },
        optReset(){
            this.optParams = {start_time: '', end_time: '', user_id: '',page: 1, per_page: 20}
            this.getOperationList()
        },
        optSearch(){
            this.optParams.page = 1
            this.getOperationList()
        },
        getPage(obj){
            this.optParams.page = obj.currentpage;
            this.optParams.per_page = obj.pagesize;
        },
        returnWorkbench(){
            var obj={};
			obj.label="销售工作台";
			obj.name="销售工作台";
            obj.content="customerSalesBench";
            this.$emit("clickClose")
            this.$emit("clickAdd",obj);
        }
    },
    mounted(){
        this.getUserList()
        this.getOperationList()
    },
    watch: {
        "optParams.page":function(){
            this.getOperationList()
        },
        "optParams.per_page":function(){
            this.getOperationList()
        },
        pages(){
            //强制刷新组件
            this.refresh= false
            this.$nextTick(()=>{
                this.refresh = true
            })
        }   
    }
}
</script>

<style lang="scss" scoped>
.customer_opt{
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background: #fff;
    padding: 10px 10px 5px;
    box-sizing: border-box;
    .right{
      float: right;
      margin-top: -3px;
    }
    .opt_table{
        flex: 1;
        width: 100%;
        margin-top: 5px;
    }
    .opt_pagin{
        margin-top: 5px;
    }
}

.customer_opt /deep/ .el-table th.gutter {display: table-cell !important;}
.customer_opt /deep/ .el-table th.gutter{display: block !important;width: 28px !important;}
.customer_opt /deep/ .el-tablecolgroup.gutter{display: block !important;width: 28px !important;}  

.customer_opt /deep/ .el-table--border, .customer_opt /deep/ .el-table--group {border: 1px solid #fff;}
.customer_opt /deep/  .el-table--border th.gutter:last-of-type {border-bottom-color: #fff;border-top: 1px solid #ddd;position: relative;top: -1px;}

</style>